import { Link } from 'react-router-dom';
import config from "../../Common/Configurations/APIConfig";
import axios from 'axios';
import { useState, useEffect } from "react";
const initialFieldValues = {
    landingPageId: "00000000-0000-0000-0000-000000000000",
    phoneNumber: "",
    email: "",
    heroSectionTitle_1: "",
    heroSectionTitle_2: "",
    heroSectionTitle_3: "",
    heroSectionParagraph: "",
    aboutus_Title: "",
    aboutus_List: "",
    about_Image: "",
    broker_Title: "",
    broker_List: "",
    broker_Image: "",
    funder_Title: "",
    funder_List: "",
    funder_Image: "",
    comingSoon_Text: "",
    signUp_Text: "",
    footer_Address: "",
    footer_CopyRights: "",
    topHeader_Color: "",
    heroSection_Color: "",
    footer_Color: "",
    footer_Facebook: "",
    footer_Instagram: "",
    footer_LinkedIn: "",
    footer_Twitter: "",
};
export default function Footer() {
    const [values, setValues] = useState(initialFieldValues);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    };

    useEffect(() => {
        GetData();
    }, []);

    const GetData = () => {
            axios.get(config.APIACTIVATEURL + config.LANDINGPAGEGET, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        setValues(response.data.data);
                    }
                })
                .catch((error) => {
                    //setError('Failed to fetch data');
                    console.error(error);
                });
        };
    return (
        <footer className="custom-footer py-5 position-relative" style={{ backgroundColor: values.footer_Color }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 mt-4"><div>
                                    <div>
                                        <img alt="logo light" height={80} width={280} src="/assets/images/logo3d.png" />
                                    </div>
                                    <div className="mt-4 text-black">
                                        <p>{values.footer_CopyRights}</p>
                                    </div>
                                </div>
                                </div>
                                <div className="col-lg-7 ms-lg-auto">
                                    <div className="row">
                                        <div className="col-sm-4 mt-4" />
                                        <div className="col-sm-3 mt-4" />
                                        <div className="col-sm-5 mt-4">
                                            <h5 className="text-black mb-0">Contact</h5>
                                            <div className="text-black mt-3">
                                                <ul className="list-unstyled ff-secondary footer-list fs-3">
                                                    {values.footer_Address==="null"?"":<li className="p-1">{values.footer_Address}</li>}
                                                    <li className="p-1">Email : {values.email}</li>
                                                    <li className="p-1">Phone : {values.phoneNumber}</li>
                                                </ul>
                                            </div>
                                            <div className="text-sm-end mt-3 mt-sm-0">
                                                <ul className="list-inline mb-0 footer-social-link">
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Facebook} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-facebook-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Twitter} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-twitter-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_LinkedIn} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-linkedin-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Instagram} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-instagram-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
    );
}